<template>
  <div class="payList">
    <navigation></navigation>
    <div style="width: 100%; height: 80px"></div>
    <div class="pay">
      <div class="head">付费资讯</div>
      <div class="payDetail">
        <ul>
          <li>
            <div class="img" @click="showData(1)">
              <img
                src="https://dongyunqichuang.oss-accelerate.aliyuncs.com/muke/images/prod/f06234449d004dbeb2e876db01d6f6c3.jpg
"
                alt=""
              />
            </div>
            <div class="title">创业大赛之赛后融资</div>
            <div class="content">
              赛后融资落地!巧妇难为无米之炊，资金是项目腾飞的翅膀!专项经费为项目的下一步发展提供资金支持，赛事的终点就是你项目启动的原点!
            </div>
          </li>
          <li>
            <div class="img" @click="showData(2)">
              <img
                src=" https://dongyunqichuang.oss-accelerate.aliyuncs.com/muke/images/prod/5377a874e9d44b61a8393ca90df1cd77.jpg
"
                alt=""
              />
            </div>
            <div class="title">创业大赛之获奖攻略</div>
            <div class="content">
              不清楚如何对标参赛?如何充分展示自身优势?创业竞赛介绍、BP文案撰写与优化、竞赛PPT制作与展示、项目路演要素训练、答辩要点......
            </div>
          </li>
          <li>
            <div class="img" @click="showData(3)">
              <img
                src="https://dongyunqichuang.oss-accelerate.aliyuncs.com/muke/images/prod/ea9b96e391b5457e93c1ef4f2cb25ff4.jpg
"
                alt=""
              />
            </div>
            <div class="title">大赛通关秘籍</div>
            <div class="content">
              中国创新创业大赛整合创新创业要素，搭建为科技型中小企业服务的平台，引导更广泛的社会资源支持创新创业，促进科技型中小企业创新发展。
            </div>
          </li>
          <li>
            <div class="img" @click="showData(4)">
              <img
                src="https://dongyunqichuang.oss-accelerate.aliyuncs.com/muke/images/prod/05b3d890aa14489f957a87684d568992.jpg
"
                alt=""
              />
            </div>
            <div class="title">初创型企业核心人才辨识、培育与激励</div>
            <div class="content">
              通过了解人，理解人，尊重人，信任人，培养人，赏识人，达到留住人，用好人的目的,那么初创型企业怎么进行核心人才的辨识、培育、激励呢?
            </div>
          </li>
          <li>
            <div class="img" @click="showData(5)">
              <img
                src="https://dongyunqichuang.oss-accelerate.aliyuncs.com/muke/images/prod/4fce153438e740f3bbda14a0ed6a7ff4.jpg
"
                alt=""
              />
            </div>
            <div class="title">高绩效团队搭建TE模型</div>
            <div class="content">
              企业的发展与企业内部项目团队的形成和运作已经紧密相联系，如何建立一个高绩效的团队，为企业发展谋福祉，已经成为众多企业经营者和管理者的主要工作目标。
            </div>
          </li>
          <li>
            <div class="img" @click="showData(6)">
              <img
                src="https://dongyunqichuang.oss-accelerate.aliyuncs.com/muke/images/prod/83e1cc22d8f0438bb5ce0639bc505976.jpg
"
                alt=""
              />
            </div>
            <div class="title">初创期企业高效运营管理体系搭建</div>
            <div class="content">
              绩效管理流于形式，内部流程割裂，制度多样，重复矛盾，导致各业务线协同效率低，资源浪费严重，所以如何建立高效的运营管理体系尤为重要。
            </div>
          </li>
        </ul>
      </div>
    </div>
    <el-dialog title="支付" :visible.sync="dialogVisible" width="width">
      <div class="top">
        <div class="zhanghao">购买账号：<span>{{status == 1 ? "已登录" : "未登录"}}</span></div>
        <div class="price">单价：<span>{{money}}</span>元</div>
      </div>
      <div class="bottom">
        <div style="float: left">支付方式：</div>
        <div class="zfb" @click="showEwm">
          <img
            style="width: 100px; height: 60px; float: left; margin-left: 40px"
            src="./img/zfb.jpg"
            alt=""
          />
        </div>
        <div class="ewm" v-show="ewmShow">
          <img src="./img/ewm.jpeg" alt="" />
        </div>
        <div class="zfb" @click="showWxEwm">
          <img
            style="width: 100px; height: 60px; float: left; margin-left: 40px"
            src="./img/wx.jpg"
            alt=""
          />
        </div>
        <div class="wxewm" v-show="wxewmShow">
          <img src="./img/ewm.jpeg" alt="" />
        </div>
      </div>
      <div class="regBtn" @click="goRegister" v-show="status == 1 ? false : true ">{{status == 1 ? "" : "立即充值"}}</div>
    </el-dialog>
  </div>
</template>
<script>
import navigation from "@/components/common/navigation";
export default {
  name: "pay",
  components: {
    navigation,
  },
  data() {
    return {
      dialogVisible: false,
      ewmShow: false,
      wxewmShow: false,
      status: 0,
      money: 0,
    };
  },
  created() {
    this.$axios.get("/v1/cloud/common/login-status")
    .then(({data})=>{
      this.status = data.status;
    });
  },
  methods: {
    showEwm() {
      this.$axios.get("/v1/cloud/common/login-status").then(({ data }) => {
        console.log(data);
        if (data.status == 1) {
          this.ewmShow= !this.ewmShow
        } else if (data.status == 0) {
          this.ewmShow = false
        }
      });
    },
    showWxEwm() {
      this.$axios.get("/v1/cloud/common/login-status").then(({ data }) => {
        console.log(data);
        if (data.status == 1) {
          this.wxewmShow= !this.wxewmShow
        } else if (data.status == 0) {
          this.wxewmShow=false
        }
      });
    },
    showData(data) {
      this.dialogVisible = true;
      console.log(data)
      switch (data) {
        case 1:
          this.money = 8;
          break;
        case 2:
          this.money = 8;
          break;
        case 3:
          this.money = 8;
          break;
        case 4:
          this.money = 8;
          break;
        case 5:
          this.money = 8;
          break;
        case 6:
          this.money = 8;
          break;
      }
    },
    goRegister() {
      this.$router.push("/register");
    },
  },
};
</script>
<style lang="less" scoped>
.payList {
  width: 100%;
  height: 1000px;
  .pay {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    .head {
      width: 100%;
      margin-top: 30px;
      height: 60px;
      background: rgb(177, 174, 174);
      border-radius: 10px;
      line-height: 60px;
      padding-left: 50px;
      font-size: 24px;
      color: #fff;
    }
    .payDetail {
      width: 100%;
      margin-top: 50px;
      li {
        list-style: none;
        float: left;
        width: 30%;
        height: 400px;
        margin: 0 20px;
        .img {
          width: 100%;
          height: 60%;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .title {
          margin: 15px 0;
          font-size: 18px;
          font-weight: 500;
        }
        .content {
          font-size: 14px;
          color: #666;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
  .top {
    width: 90%;
    height: 100px;
    background: rgba(246, 246, 246, 1);
    padding: 20px;
    margin: 0 auto;
    .zhanghao {
      margin-bottom: 20px;
    }
  }
  .bottom {
    padding: 40px 100px;
    height: 100px;
    position: relative;
    img {
      margin-top: -20px;
    }
    .ewm {
      width: 100px;
      height: 100px;
      position: absolute;
      top: -55px;
      left: 210px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .wxewm {
      width: 100px;
      height: 100px;
      position: absolute;
      top: -55px;
      left: 350px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .regBtn {
    width: 150px;
    height: 40px;
    background-color: red;
    margin: 0 auto;
    text-align: center;
    line-height: 40px;
    color: #fff;
    cursor: pointer;
  }
}
</style>